export const COLUMN_VISUAL_DIST_DATA_KEY = "Count";
